import { useState } from 'react'
import { Annotation } from 'types'

export const useAnnotations = (): [
  Annotation[],
  Annotation | void,
  React.Dispatch<React.SetStateAction<Annotation | undefined>>,
  () => void,
  (previousAnnotations: Annotation[]) => void,
  (updatedAnnotation: Annotation) => void,
  (annotationToDelete: Annotation) => void,
  (annotationToCancelDelete: Annotation) => void,
] => {
  const [annotations, setAnnotations] = useState<Annotation[]>([])
  const [currentAnnotation, setCurrentAnnotation] = useState<Annotation>()

  const setPreviousAnnotations = (previousAnnotations: Annotation[]) => {
    setAnnotations(previousAnnotations)
  }

  const addAnnotation = () => {
    if (currentAnnotation) {
      setAnnotations([
        ...annotations,
        { ...currentAnnotation, notPersisted: true },
      ])
      setCurrentAnnotation(undefined)
    }
  }

  const updateAnnotation = (annotation: Annotation) => {
    const index = annotations.findIndex(
      (a: Annotation) => a.data.id === annotation.data.id,
    )
    const newAnnotations = annotations.slice()
    newAnnotations.splice(index, 1, { ...annotation })
    setAnnotations(newAnnotations)
  }

  const deleteAnnotation = (annotation: Annotation) => {
    const index = annotations.findIndex(
      (a: Annotation) => a.data.id === annotation.data.id,
    )
    const newAnnotations = annotations.slice()
    newAnnotations.splice(index, 1, { ...annotation, _destroy: true })
    setAnnotations(newAnnotations)
  }

  const undoDeleteAnnotation = (annotation: Annotation) => {
    const index = annotations.findIndex(
      (a: Annotation) => a.data.id === annotation.data.id,
    )
    const newAnnotations = annotations.slice()
    newAnnotations.splice(index, 1, { ...annotation, _destroy: false })
    setAnnotations(newAnnotations)
  }

  return [
    annotations,
    currentAnnotation,
    setCurrentAnnotation,
    addAnnotation,
    setPreviousAnnotations,
    updateAnnotation,
    deleteAnnotation,
    undoDeleteAnnotation,
  ]
}
